// src/components/Tester/ReviewModal.jsx
import React, {useEffect, useMemo} from "react";
import {Modal, Typography, Button, Tag, Divider} from "antd";

const {Title, Text} = Typography;

/**
 * Props:
 * - open, onClose, onSubmit
 * - pages, answers, setCurrent, finish
 * - moduleTitle
 * - canGoNext (true => keyingi step bor)
 * - onNextStep()
 */
export default function ReviewModal({
                                        open,
                                        onClose,
                                        onSubmit,
                                        pages,
                                        answers,
                                        setCurrent,
                                        finish,
                                        moduleTitle,
                                        canGoNext = false,
                                        onNextStep = () => {},
                                    }) {
    const stats = useMemo(() => {
        let answered = 0, unanswered = 0;
        for (const p of pages) {
            if (p?.id && Object.prototype.hasOwnProperty.call(answers, p.id)) answered++;
            else unanswered++;
        }
        return {answered, unanswered, total: pages.length};
    }, [pages, answers]);

    const itemClass = (qid) =>
        Object.prototype.hasOwnProperty.call(answers, qid)
            ? "bbq-item answered"
            : "bbq-item unanswered";

    useEffect(() => {
        if (finish) localStorage.removeItem("selectedPageKey");
    }, [finish]);

    const handleClick = (key) => {
        setCurrent(key);
        setTimeout(() => onClose?.(), 0);
        localStorage.setItem("selectedPageKey", String(key));
    };

    return (
        <Modal
            open={open}
            closable={false}
            width={820}
            centered
            footer={null}
            styles={{
                mask: { backdropFilter: "blur(8px)", backgroundColor: "rgba(0,0,0,0.35)" },
            }}
        >
            {/* Header */}
            <div style={{ textAlign: "center" }}>
                <Title level={2} style={{ marginBottom: 8 }}>Check Your Work</Title>
                <Text>
                    Practice rejimida tayyor bo‘lganda <b>Next</b>{' '}
                    {!canGoNext && <>/ <b>Submit &amp; Finish</b></>} ni bosing. Test kuni keyingi modulga faqat vaqt tugaganda o‘tasiz.
                </Text>
            </div>

            {/* Body */}
            <div style={{
                marginTop: 24,
                border: "1px solid #eee",
                borderRadius: 12,
                padding: 16,
                boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
            }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Title level={4} style={{ margin: 0 }}>
                        {moduleTitle || "Module: Questions"}
                    </Title>
                    <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                        <Tag bordered={false}>Unanswered</Tag>
                        <Tag color="blue" bordered={false}>Answered</Tag>
                    </div>
                </div>
                <Divider style={{ margin: "12px 0" }} />

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(52px, 1fr))",
                        gap: 12
                    }}
                >
                    {pages.map((page) => (
                        <button
                            key={page.key}
                            className={itemClass(page.id)}
                            onClick={() => handleClick(page?.key)}
                        >
                            {page.key}
                        </button>
                    ))}
                </div>

                <div style={{ marginTop: 16, display: "flex", gap: 16 }}>
                    <Text strong>Answered:</Text><Text>{stats.answered}</Text>
                    <Text strong>Unanswered:</Text><Text>{stats.unanswered}</Text>
                    <Text strong>Total:</Text><Text>{stats.total}</Text>
                </div>
            </div>

            {/* Footer */}
            <div style={{ marginTop: 24, textAlign: "center", display: "flex", gap: 12, justifyContent: "center" }}>
                <Button onClick={onClose}>Return</Button>

                {canGoNext && (
                    <Button type="primary" onClick={onNextStep}>
                        Next Step
                    </Button>
                )}

                {/* [FIX] Submit faqat oxirgi stepda ko‘rinsin */}
                {!canGoNext && (
                    <Button type="primary" danger onClick={onSubmit}>
                        Submit &amp; Finish
                    </Button>
                )}
            </div>

            <style>{`
        .bbq-item {
          height: 48px;
          min-width: 48px;
          border: 2px dashed #bfbfbf;
          border-radius: 8px;
          background: #fff;
          cursor: pointer;
          font-weight: 600;
        }
        .bbq-item.answered {
          border-style: solid;
          border-color: #1677ff;
          color: #1677ff;
        }
        .bbq-item:hover { filter: brightness(0.95); }
      `}</style>
        </Modal>
    );
}
